import axios from 'axios';

const VALIDATE_PARTNERSHIP_URL =
    'https://personal-d4yby5if.outsystemscloud.com/Booking_API/rest/Partnerships/ValidateCode';

function parseIsValid(raw) {
    if (raw === true || raw === 'true' || raw === 'True' || raw === 1) return true;
    if (raw === false || raw === 'false' || raw === 'False' || raw === 0) return false;

    if (typeof raw === 'string') {
        const trimmed = raw.trim().toLowerCase();
        if (trimmed === 'true') return true;
        if (trimmed === 'false') return false;
    }

    if (raw && typeof raw === 'object') {
        const nested =
            raw.IsValid ??
            raw.isValid ??
            raw.Valid ??
            raw.valid ??
            raw.Result ??
            raw.result;
        if (nested !== undefined) return parseIsValid(nested);
    }

    return false;
}

export async function validatePartnershipCode(code) {
    const response = await axios.get(VALIDATE_PARTNERSHIP_URL, {
        params: { Code: code.trim() }
    });
    return parseIsValid(response.data);
}
